import prizeTag from "@assets/web-v3-images/prize-tag.png";
// import { ImagePlaceholder } from "@/component";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import PATH from "@config/PATH";
import { PrizeType } from "@types";
import grandPrize from "@assets/web-v3-images/grand-prize.png";
import IntroTourHome from "@/page/components/components/IntroTourHome";
/** Khung ảnh giải: dùng chung cho <img> và div giữ chỗ khi không có ảnh, để hai
 *  nhánh luôn chiếm đúng một chỗ như nhau.
 *
 *  aspect theo tỉ lệ FILE (518×594), không phải 403/499 của design: 403/499 là
 *  tỉ lệ thân máy, mà thân máy chỉ chiếm 61%×66% file do PNG có viền glow trong
 *  suốt. Giữ khung = tỉ lệ file thì thân máy bên trong tự ra đúng 403/499; ép
 *  403/499 lên cả file sẽ letterbox và đẩy thân máy tụt ~3.2vw khỏi bục. */
// Cap các trị vw theo BỀ RỘNG KHUNG thật = 768px (.main-layout-website), không
// phải 880px như trước -> ảnh giải vừa khít khung trên desktop:
//   max-w 537 = 70%×768 · -mx cap 77 = 10%×768 · (translate 11.4vw cap 87.6 = 11.4%×768)
const PRIZE_FRAME_CLASS =
  "-mx-[10vw] aspect-518/594 w-[70vw] max-w-[537px] md:-mx-[min(10vw,77px)]";

// Nhịp chuyển ảnh trong slideshow (ms).
const PRIZE_SLIDE_MS = 3000;

/**
 * Khu vực trưng bày giải thưởng: nút History / Prize Pool hai bên, ảnh sản phẩm
 * ở giữa trên bục (podium), kèm tag giá treo bên phải.
 *
 * Bục nằm trong ảnh nền home-bg.png (bg-contain, rộng = 100vw) nên mọi kích
 * thước/khoảng cách ở đây tính theo vw để ảnh giải luôn đứng đúng trên bục
 * ở mọi cỡ màn hình.
 */
const PrizeShowcase = ({
  prize = PrizeType,
  isDailyReward = false,
}) => {
  const { t } = useTranslation();
  /* Swing của tag giá chỉ chạy ở màn home. Không suy ra được từ `isDailyReward`:
     HomePage (nơi render component này) được mount ở CẢ "/" lẫn "/bid/:id"
     (routerList.jsx) nên phải so trực tiếp pathname với PATH.HOME. */
  const { pathname } = useLocation();
  const isHome = pathname === PATH.HOME;
  /* prize.image là chuỗi nhiều link ảnh ngăn nhau bởi "," -> tách hết để chạy
     slideshow. Ảnh nào tải lỗi thì loại khỏi danh sách (lưu trong `failed`).
     Không còn ảnh hợp lệ thì fallback grandPrize để khung luôn có kích thước. */
  const [failed, setFailed] = useState({});
  const [index, setIndex] = useState(0);

  const images = useMemo(() => {
    const list = (prize?.image || "")
      .split(",")
      .map((s) => s.trim())
      .filter((src) => src && !failed[src]);
    return list.length ? list : [];
  }, [prize?.image, failed]);

  // Prize đổi -> quay về ảnh đầu và xoá cờ lỗi cũ.
  useEffect(() => {
    setIndex(0);
    setFailed({});
  }, [prize?.image]);

  // Tự chuyển ảnh (vòng lặp) khi có nhiều hơn 1 ảnh.
  useEffect(() => {
    if (images.length <= 1) return undefined;
    const id = setInterval(
      () => setIndex((i) => (i + 1) % images.length),
      PRIZE_SLIDE_MS,
    );
    return () => clearInterval(id);
  }, [images.length]);

  const activeIndex = index % images.length;

  return (
    <>
      <IntroTourHome />
      <section className="relative">
        {/* Lưới 3 cột để ảnh giải luôn ở chính giữa trục bục, bất kể độ rộng 2 nút */}
        <div className="grid items-center justify-items-center">
          {/* Ảnh giải + tag giá: dịch bằng calc(vw) để thân máy luôn đứng trên mặt
            bục trong home-bg.png (mặt bục ≈ 1.09 × chiều rộng màn hình tính từ
            đỉnh trang). PNG có lề trong suốt lớn (thân máy chỉ chiếm 61% ngang
            × 66% dọc file ảnh) nên ảnh render 70vw để thân máy ≈ 43% màn hình
            như mock, kèm margin âm ngang bù phần lề để không phá lưới 3 cột;
            hằng số px bù chiều cao cố định của header ở mỗi breakpoint.
            min() đóng băng phần vw từ 880px vì #root cap trang ở 880px. */}
          {/* mb lặp lại đúng calc của translate-y: translate chỉ dịch phần nhìn
            thấy, không đổi chiều cao layout — mb đồng bộ hai thứ để nội dung
            phía sau (GuessPriceCard) luôn nằm sát dưới bục ở mọi cỡ màn. */}
          <div className={`${isDailyReward ? "translate-y-[calc(11.4vw-74px)] mb-[calc(11.4vw-64px)] md:translate-y-[calc(min(11.4vw,87.6px)-107px)] md:mb-[calc(min(11.4vw,87.6px)-64px)]" : "translate-y-[calc(11.4vw-121px)] mb-[calc(11.4vw-121px)] md:translate-y-[calc(min(11.4vw,87.6px)-198px)] md:mb-[calc(min(11.4vw,87.6px)-198px)]"} pointer-events-none relative`}>
            {/* Không có ảnh (hoặc ảnh lỗi) thì giữ chỗ bằng div nền trong suốt cùng
              khung: tag giá định vị theo % của khối này nên khung phải luôn có
              kích thước, nếu không tag sẽ rơi lên bục. */}
            {/* Slideshow: xếp chồng tất cả ảnh trong cùng khung, ảnh đang hiện
              fade-in (opacity-100), còn lại ẩn. Khung (PRIZE_FRAME_CLASS) giữ
              kích thước, ảnh phủ absolute inset-0. */}
            <div className={`${PRIZE_FRAME_CLASS} relative`}>
              <div className="aspect-518/270 sm:aspect-518/340 w-full relative top-[10%] sm:top-[11%]">
                {images.map((src, i) => (
                  <img
                    key={`${src}-${i}`}
                    src={src}
                    alt="prize"
                    onError={() => setFailed((f) => ({ ...f, [src]: true }))}
                    className={`absolute inset-0 size-full object-contain transition-opacity duration-700 ease-in-out ${i === activeIndex ? "opacity-100" : "opacity-0"
                      }`}
                  />
                ))}
              </div>
            </div>

            {/* Tag giá: nền prize-tag.png (pin + dây + biển nghiêng có sẵn trong
              ảnh). Kích thước/vị trí theo % của khối ảnh giải nên tự co giãn:
              pin ghim vào mép phải thân máy, biển treo ở góc dưới phải như mock.
              Chữ xoay -6° theo độ nghiêng của tấm biển trong ảnh. */}
            {
              !isDailyReward && (
                /* origin đặt ở ĐẦU GHIM (pin nằm ~47% ngang, ~8% dọc của
                   prize-tag.png) để tag đảo qua lại như biển treo trên đinh; để
                   mặc định origin center thì nó xoay quanh tâm biển, trông như
                   đang bị lắc ngang chứ không phải treo. */
                <div className={`@container absolute right-[-40%] bottom-[13%] aspect-321/256 w-[68%] origin-[47%_8%] animate-tag-swing`}>
                  <img src={prizeTag} alt="" className="size-full" />
                  <div className="absolute inset-x-[6%] inset-y-0 grid gap-1.5 rotate-[-7.5deg] place-content-center pt-[24%] text-center">
                    {/* Tên giải dài thì cho xuống dòng (bỏ whitespace-nowrap); break-words
                  để từ quá dài cũng ngắt được, không tràn khỏi biển tag. */}
                    <p className="break-words text-[6.5cqw] font-extrabold leading-tight text-[#FEF0C7]">
                      {prize.name}
                    </p>
                    <p className="relative whitespace-nowrap text-[10.5cqw] font-extrabold leading-tight">
                      <span
                        aria-hidden="true"
                        className="absolute inset-0 text-[#C33E00] [-webkit-text-stroke:0.31cqw_#C33E00] [text-shadow:0_0.62cqw_1.1cqw_#B11111]"
                      >
                        {prize.price.toLocaleString("en-US")} MMK
                      </span>
                      <span className="relative text-transparent bg-linear-to-b from-[#FFF8D2] via-[#FCEB7C] via-49% to-[#FFF5BF] bg-clip-text">
                        {prize.price.toLocaleString("en-US")} MMK
                      </span>
                    </p>
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </section>
    </>
  );
};

export default PrizeShowcase;
